function escapeHtml(text) {
  const div = document.createElement('div');
  div.innerText = text;
  return div.innerHTML;
}

function textareaTextToArrayWithParams(text) {
  if (text === '' || text === undefined) {
    return [];
  }
  return text
    .split('\r')
    .map((str) => {
      const imgObj = parseImageString(str.trim());
      if (imgObj.full_image_url) {
        return imgObj;
      }
      return false;
    })
    .filter(Boolean);
}

function textareaTextToArrayWithParamsOld(text) {
  if (text === '' || text === undefined) {
    return [];
  }
  return text
    .split('\r')
    .map((str) => {
      const imgObj = parseImageStringOld(str.trim());
      if (imgObj.src) {
        return imgObj;
      }
      return false;
    })
    .filter(Boolean);
}

function textareaTextToArray(text) {
  if (text === '' || text === undefined) {
    return [];
  }
  return text.split('\r').map((str) => str.trim());
}

function parseImageString(str) {
  const [...params] = str.split('§');
  const obj = {};
  params.forEach((param) => {
    const [key, value] = param.split('=');
    obj[key] = value;
  });
  return obj;
}

function parseImageStringOld(str) {
  const [src, ...params] = str.split('§');
  const obj = { src };
  params.forEach((param) => {
    const [key, value] = param.split('=');
    obj[key] = value;
  });
  return obj;
}

export {
  escapeHtml,
  textareaTextToArray,
  textareaTextToArrayWithParams,
  textareaTextToArrayWithParamsOld,
  parseImageStringOld,
};
